'use client'
import Stack from '@mui/material/Stack'
import { FC } from 'react'
import CountUp from 'react-countup'

import Pill from '@/components/Pill'
import usePayhawkNumCalcs from '@/hooks/usePayhawkNumCalcs'

const INTERVAL_SECONDS = 60

const PayhawkCaseStudyStats: FC<{}> = () => {
    const counters = usePayhawkNumCalcs({ intervalSeconds: INTERVAL_SECONDS })

    return (
        <Stack
            direction={{
                xs: 'column',
                sm: 'column',
                md: 'row',
                lg: 'row',
                xl: 'row',
            }}
            spacing={{
                xs: 1,
                sm: 1,
                md: 3,
                lg: 3,
                xl: 3,
            }}
        >
            <Pill
                header={'ADOPTION'}
                title={'200+ customers'}
                backgroundImageSrc={'/images/payhawk-case-study/payhawk-stat-adoption.png'}
            />
            <Pill
                header={'USAGE'}
                title={
                    <>
                        {counters ? (
                            <CountUp
                                duration={INTERVAL_SECONDS}
                                start={counters.prev}
                                end={counters.current}
                                separator={','}
                                decimals={0}
                                suffix={' calculations'}
                            />
                        ) : (
                            <>500,000 calculations</>
                        )}
                    </>
                }
                backgroundImageSrc={'/images/payhawk-case-study/payhawk-stat-usage.png'}
            />
        </Stack>
    )
}

export default PayhawkCaseStudyStats
